import React, { useContext, useEffect, useState } from 'react';
import { Loader, TextStyle } from 'pixi.js'
import { GlowFilter } from 'pixi-filters';
import { AnimatedSprite, Container, Sprite, withFilters, Text } from '@inlet/react-pixi'

import { ConvertDateString } from '../../../utils/helpers/dateformat/ConvertDateString'
import HomeContext from '../../../context/home-context';

const Filters = withFilters(Container, {
    glow: GlowFilter,
});

let drumstickTextures = [];
let berryTextures = [];

const DailyChest = () => {
    const { homeContext, dispatch, notiOpenClick } = useContext(HomeContext);
    const loader = Loader.shared;
    const [claiming, SetClaiming] = useState(false);
    const [filter, setFilter] = React.useState(0);
    const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;

    let tomorrow = new Date();
    tomorrow.setHours(0, 0, 0, 0);
    tomorrow.setDate(tomorrow.getDate() + 1);

    const titleStyle = new TextStyle({
        fontFamily: '"Source Sans Pro", Helvetica, sans-serif',
        fontSize: 16,
        fill: "white",
        wordWrap: true,
        wordWrapWidth: 250,
        align: "center",

    });
    const chestId = React.useRef();
    const textId = React.useRef();
    const timerId = React.useRef();

    for (let i = 0; i <= 19; i++) {
        drumstickTextures.push(loader.resources["./assets/images/components/island/spritesheets/foods/chest_drumstick.json"].textures[`SIT_Characters_drumstick_${i}.png`]);
        berryTextures.push(loader.resources["./assets/images/components/island/spritesheets/foods/chest_berry.json"].textures[`SIT_Characters_berries_${i}.png`]);
    }

    useEffect(() => {
        if (!homeContext.dailyChestClaim.ableToClaim) {
            const interval = setInterval(() => {
                dailyChestCounter(interval)
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [homeContext]);

    const dailyChestCounter = (interval) => {
        let now = new Date().getTime();
        let distance = tomorrow.getTime() - now;

        let hourInt = Math.floor((distance % (day)) / (hour));
        let minuteInt = Math.floor((distance % (hour)) / (minute));
        let secondInt = Math.floor((distance % (minute)) / second);

        hourInt = hourInt < 10 ? "0" + hourInt : hourInt;
        minuteInt = minuteInt < 10 ? "0" + minuteInt : minuteInt;
        secondInt = secondInt < 10 ? "0" + secondInt : secondInt;

        let t = hourInt + ":" + minuteInt + ":" + secondInt;
        if (timerId.current !== null && timerId.current !== undefined) {
            timerId.current.text = t;
        }
        //do something later when date is reached
        if (distance < 0) {
            clearInterval(interval);
            //homeContext.dailyChestClaim.ableToClaim = true;
            //dispatch({ type: 'SET_DAILYCHESTCLAIM', dailyChestClaim: homeContext.dailyChestClaim });
        }             
    }

    const claim = () => {
        if (textId.current !== null && textId.current !== undefined) {
            chestId.current.visible = false;
            if (homeContext.dailyChestClaim.ableToClaim) {
                SetClaiming(true);
                textId.current.text = "Opening...";
                const timeout = setTimeout(() => {
                    complete()
                }, 5000);
            }
            else {
                alert("You need to wait");
            }

        }
    }

    const complete = () => {
        SetClaiming(false);
        notiOpenClick();
    }

    return (
        <>
            {
                homeContext.dailyChestClaim.ableToClaim ?
                    <>
                        <AnimatedSprite
                            textures={homeContext.monsterMenu.cluster === "ENG" || homeContext.monsterMenu.cluster === "CEFT" ? berryTextures: drumstickTextures}
                            isPlaying={claiming}
                            initialFrame={0}
                            x={50} y={40}
                            scale={{ x: 0.2, y: 0.2 }}
                            animationSpeed={0.09}
                        />
                        <Filters scale={1} glow={{ distance: 100, outerStrength: filter, innerStrength: filter / 4, quality: 0, color: '0xf5f5f5' }}>
                            <Sprite ref={chestId} interactive={true} buttonMode={true}
                                texture={loader.resources["./assets/images/components/island/spritesheets/foods/chest_drumstick.json"].textures[`SIT_Characters_drumstick_0.png`]}
                                x={50} y={40}
                                scale={{ x: 0.2, y: 0.2 }}
                                pointerdown={() => {
                                    claim()
                                }}
                                pointerover={() => setFilter(4)}
                                pointerout={() => setFilter(0)}
                            />
                        </Filters>
                        <Container x={15} y={130}>

                            <Text
                                ref={textId}
                                text='Open now!'
                                x={30}
                                y={5}
                                style={titleStyle}
                            />
                        </Container>
                    </>
                    :
                    <>

                        <Sprite
                            texture={loader.resources["./assets/images/components/island/spritesheets/foods/chest_drumstick.json"].textures[`SIT_Characters_drumstick_0.png`]}
                            x={50} y={40}
                            scale={{ x: 0.2, y: 0.2 }}

                        />

                        <Container x={15} y={130}>
                            <Text
                                ref={timerId}
                                text='00:00:00'
                                x={40}
                                y={5}
                                style={titleStyle}
                            />
                        </Container>
                    </>
            }
        </>
    );
};

export { DailyChest as default }